export default "__VITE_ASSET__25eefa2d__"